import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function LojaCancelado() {
    return (
        <div className="container-x py-24 flex justify-center" data-testid="loja-cancelado">
            <div className="max-w-md w-full rounded-2xl border border-border bg-white p-8 text-center">
                <XCircle className="h-12 w-12 mx-auto text-muted-foreground" />
                <h1 className="mt-4 font-heading text-2xl font-extrabold text-primary">Pagamento cancelado</h1>
                <p className="mt-2 text-sm text-muted-foreground">Não foi cobrado nenhum valor. O seu carrinho continua guardado.</p>
                <div className="mt-6 flex gap-3 justify-center">
                    <Link to="/checkout" className="inline-flex items-center rounded-full bg-secondary px-5 py-2.5 text-sm font-bold text-secondary-foreground">Tentar de novo</Link>
                    <Link to="/loja" className="inline-flex items-center rounded-full border border-border px-5 py-2.5 text-sm font-bold text-primary">Voltar à loja</Link>
                </div>
            </div>
        </div>
    );
}
